import * as React from 'react';
import {
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Switch,
    TextField,
    Zoom,
} from "@material-ui/core";
import CheckoutFieldsSection from "./CheckoutFieldsSection";
import { COMMON_ALLERGIES, COMMON_HEALTH_CONDITIONS } from "../../../../utils/HealthProfileConstants";

import {LoadingSpinner}from "../../../../utils/LoadingSpinner";
import MedicationSelection from "../../../../common/MedicationSelection";

interface IProps {
    data?: any;
    gender?: any;
    forCheckout?: any;
    forOrder?: any;
    forAddPrescription?: any;
    medications: any[];
}

interface IState {
    addInsurancePlan: any,
    binNumber: any,
    binNumber2: any,
    binNumber3: any,
    cardHolderId: any,
    cardHolderId2: any,
    cardHolderId3: any,
    commonAllergies: any[],
    commonHealthConditions: any[],
    defaultMedication: any,
    groupNumber: any,
    groupNumber2: any,
    groupNumber3: any,
    insurancePlan: any,
    medicationList: any[],
    pcn: any,
    pcn2: any,
    pcn3: any,
    pregnantOrNursing: any,
    setInsuranceAsPrimary: any,
    setInsuranceAsPrimary2: any,
    setInsuranceAsPrimary3: any,
    showAdditionalInsurancesFields: boolean,
    showAdditionalInsurancesFields2: boolean,
    showFakeOutOption: any,
    showOrderSection: any,
    spi: any,
    staleHealthProfile: boolean,
}

class HealthProfileFieldsSection extends React.Component<IProps, IState> {
    private checkoutFieldsSection: any;

    constructor(props: IProps) {
        super(props);
        this.handleSetAddInsurancePlan = this.handleSetAddInsurancePlan.bind(this);

        this.state = {
            addInsurancePlan: false,
            binNumber: '456789',
            binNumber2: '',
            binNumber3: '',
            cardHolderId: '123456789',
            cardHolderId2: '',
            cardHolderId3: '',
            commonAllergies: ['523cbe1aad393f143f002a27'],
            commonHealthConditions: ['548b2cc269702d1e63320000'],
            defaultMedication: '',
            groupNumber: '',
            groupNumber2: '',
            groupNumber3: '',
            insurancePlan: 'Continue Without Insurance',
            medicationList: [],
            pcn: 'XPAY',
            pcn2: '',
            pcn3: '',
            pregnantOrNursing: 'No',
            setInsuranceAsPrimary: true,
            setInsuranceAsPrimary2: false,
            setInsuranceAsPrimary3: false,
            showAdditionalInsurancesFields: false,
            showAdditionalInsurancesFields2: false,
            showFakeOutOption: false,
            showOrderSection: false,
            spi: '6633950178005',
            staleHealthProfile: false,
        };

        this.handleInsurancePlan = this.handleInsurancePlan.bind(this);
        this.handleCardHolderId = this.handleCardHolderId.bind(this);
        this.handleCardHolderId2 = this.handleCardHolderId2.bind(this);
        this.handleCardHolderId3 = this.handleCardHolderId3.bind(this);
        this.handleBinNumber = this.handleBinNumber.bind(this);
        this.handleBinNumber2 = this.handleBinNumber2.bind(this);
        this.handleBinNumber3 = this.handleBinNumber3.bind(this);
        this.handlePcn = this.handlePcn.bind(this);
        this.handlePcn2 = this.handlePcn2.bind(this);
        this.handlePcn3 = this.handlePcn3.bind(this);
        this.handleGroupNumber = this.handleGroupNumber.bind(this);
        this.handleGroupNumber2 = this.handleGroupNumber2.bind(this);
        this.handleGroupNumber3 = this.handleGroupNumber3.bind(this);
        this.handlePrescriber = this.handlePrescriber.bind(this);
        this.handleMedicationOrVitaminName = this.handleMedicationOrVitaminName.bind(this);
        this.handleCommonAllergies = this.handleCommonAllergies.bind(this);
        this.handlePregnantOrNursing = this.handlePregnantOrNursing.bind(this);
        this.handleCommonHealthConditions = this.handleCommonHealthConditions.bind(this);
        this.handleSetInsuranceAsPrimary = this.handleSetInsuranceAsPrimary.bind(this);
        this.handleSetInsuranceAsPrimary2 = this.handleSetInsuranceAsPrimary2.bind(this);
        this.handleSetInsuranceAsPrimary3 = this.handleSetInsuranceAsPrimary3.bind(this);
        this.handleStaleHealthProfile = this.handleStaleHealthProfile.bind(this);
        this.handleShowAdditionalInsurancesFields = this.handleShowAdditionalInsurancesFields.bind(this);
        this.handleShowAdditionalInsurancesFields2 = this.handleShowAdditionalInsurancesFields2.bind(this);

        this.addMedication = this.addMedication.bind(this);
        this.removeMedication = this.removeMedication.bind(this);
    }

    public render() {
        // @ts-ignore
        const showLoadingSpinner = this.props.medications.length === 0;
        if (!showLoadingSpinner && this.state.medicationList.length === 0) {
            for (const medication of this.props.medications) {
                if (medication.defaultOption) {
                    this.setState({medicationList: [medication.drugId]})
                    this.setState( {defaultMedication: medication.drugId})
                    this.setState({showFakeOutOption: medication.allowFakeout})
                    break;
                }
            }
        }

        const showAddInsurancePlan = this.state.addInsurancePlan;

        return (

            <Grid item xs={12}>
                {showLoadingSpinner && <LoadingSpinner/>}

                <Grid item xs={12}>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        {!this.props.forAddPrescription && <Grid item xs>
                            <InputLabel style={{
                                color: "red",
                                fontSize: 18,
                                fontWeight: "bold",
                            }}>Health Profile</InputLabel>
                        </Grid>}

                        <Grid item xs>
                            <FormControl>
                                <InputLabel>Prescriber (Optional)</InputLabel>
                                <Select
                                    value={this.state.spi}
                                    style={{width: 225}}
                                    onChange={this.handlePrescriber}
                                >
                                    <MenuItem value="None">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="1013626948011">
                                        <em>Kristina Bowen,
                                            KVH Orthopedics,
                                            611 S Chestnut St, Ste D,
                                            Ellensburg, WA, 98926,
                                            Phone number: (509) 933-8700</em>
                                    </MenuItem>
                                    <MenuItem value="6633950178005">
                                        <em>JOHN KIHM,
                                            regional medical associates, p,
                                            3811 N Roxboro St, Ste B,
                                            Durham, NC, 27704,
                                            Phone number: (919) 471-3351</em>
                                    </MenuItem>
                                    <MenuItem value="6299122013003">
                                        <em>Robert Mackinder,
                                            Spectrum Health,
                                            7128 Fulton St E,
                                            Ada, MI, 49301,
                                            Phone number: (616) 825-3530</em>
                                    </MenuItem>
                                    <MenuItem value="6261285632002">
                                        <em>Gregory Granrud,
                                            Healtheast Heart Care Physicians,
                                            45 10th St W,
                                            Saint Paul, MN, 55102,
                                            Phone number: (651) 326-4327</em>
                                    </MenuItem>
                                    <MenuItem value="5081356803001">
                                        <em>DANIEL BROWNFIELD,
                                            2606 Hospital Blvd, Ste B,
                                            Corpus Christi, TX, 78405,
                                            Phone number: (361) 902-4789</em>
                                    </MenuItem>
                                    <MenuItem value="8208966520001">
                                        <em>Gary Schneider, DO,
                                            3139 Highland Ave 2nd Floor Interna,
                                            Cincinnati, OH, 45219,
                                            Phone number: (513) 584-4505</em>
                                    </MenuItem>
                                    <MenuItem value="6594995717002">
                                        <em>Brian Loskill,
                                            LOSKILL, BRIAN,
                                            3029 Newcastle Loop,
                                            Myrtle Beach, SC, 29588,
                                            Phone number: (843) 215-8868</em>
                                    </MenuItem>
                                    <MenuItem value="6809068276002">
                                        <em>Sarah Bragg,
                                            UABC,
                                            1141 Payton Way,
                                            Leeds, AL, 35094,
                                            Phone number: (205) 699-0729</em>
                                    </MenuItem>
                                    <MenuItem value="6728920896018">
                                        <em>Yasmin Deliz, DO
                                            Linwood,
                                            2106 New Rd, Ste D4,
                                            Linwood, NJ, 08221,
                                            Phone number: (609) 926-8899</em>
                                    </MenuItem>
                                    <MenuItem value="6013294536008">
                                        <em>Cynthia Kang-Rotondo,
                                            Greater Knoxville Dermatology,
                                            7730 Dannaher Dr,
                                            Powell, TN 37849,
                                            Phone number: (865) 524-7107</em>
                                    </MenuItem>
                                    <MenuItem value="6044315631005">
                                        <em>James Bertel,
                                            100 Kings Way E,
                                            Ste D2,
                                            Sewell, NJ 08080,
                                            Phone number: (844) 542-2273</em>
                                    </MenuItem>
                                    <MenuItem value="6145116342004">
                                        <em>Hugo Twaddle,
                                            2649 Schoenersville Rd,
                                            Ste 201,
                                            Bethlehem, PA 18017,
                                            Phone number: (484) 884-8110</em>
                                    </MenuItem>
                                    <MenuItem value="6794505076010">
                                        <em>Sarah Carpenter,
                                            65-1267,
                                            Kawaihae Road,
                                            Kamuela, HI 96743,
                                            Phone number: (808) 881-4745</em>
                                    </MenuItem>
                                    <MenuItem value="8215456027200">
                                        <em>Joseph Abayev,
                                            3750 Ralph Avenue,
                                            Apartment 417,
                                            Owensboro, KY 42303,
                                            Phone number: (888) 402-6916</em>
                                    </MenuItem>
                                    <MenuItem value="6582785534001">
                                        <em>Myna Kuo,
                                            414 Uluniu St,
                                            Kailua, HI 96734-2556,
                                            Phone number: (808) 523-1600</em>
                                    </MenuItem>
                                    <MenuItem value="6977486979012">
                                        <em>Aarti Kulkarni,
                                            9725 Wilshire Boulevard,
                                            Beverly Hills, CA 90212,
                                            Phone number: (888) 663-6331</em>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {!this.props.forAddPrescription && <Grid item xs>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Insurance Plan (Required)</FormLabel>
                                <RadioGroup aria-label="insurance" name="insurance" value={this.state.insurancePlan}
                                            onChange={this.handleInsurancePlan}
                                            style={{width: 225}}>
                                    {this.state.spi !== 'None' && <FormControlLabel value="Add Insurance Plan" control={
                                        <Radio/>
                                    } label="Add Insurance Plan"/>}

                                    {showAddInsurancePlan && <Grid
                                        container
                                        direction="column"
                                        justify="center"
                                        alignItems="center"
                                        spacing={3}
                                    >

                                        <Grid item xs>
                                            <TextField
                                                style={{width: 225}}
                                                label="MEMBER ID # (Required)"
                                                variant="outlined"
                                                value={this.state.cardHolderId}
                                                onChange={this.handleCardHolderId}
                                            />
                                        </Grid>

                                        <Grid item xs>
                                            <TextField
                                                style={{width: 225}}
                                                label="RXBIN # (Required)"
                                                variant="outlined"
                                                value={this.state.binNumber}
                                                onChange={this.handleBinNumber}
                                            />
                                        </Grid>

                                        <Grid item xs>
                                            <TextField
                                                style={{width: 225}}
                                                label="RX GROUP # (Optional)"
                                                variant="outlined"
                                                value={this.state.groupNumber}
                                                onChange={this.handleGroupNumber}
                                            />
                                        </Grid>

                                        <Grid item xs>
                                            <TextField
                                                style={{width: 225}}
                                                label="RXPCN # (Optional)"
                                                variant="outlined"
                                                value={this.state.pcn}
                                                onChange={this.handlePcn}
                                            />
                                        </Grid>

                                        <Grid item xs>
                                            <FormControl component="fieldset">
                                                <FormGroup style={{width: 225}}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.setInsuranceAsPrimary}/>
                                                        }
                                                        label="Set Insurance As Primary"
                                                        onChange={this.handleSetInsuranceAsPrimary}
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </Grid>

                                        <FormControlLabel control={<Switch checked={this.state.showAdditionalInsurancesFields} onChange={this.handleShowAdditionalInsurancesFields}/>} label="Add more insurance"/>

                                        {this.state.showAdditionalInsurancesFields && <Grid
                                            container
                                            direction="column"
                                            justify="center"
                                            alignItems="center"
                                            spacing={3}
                                        >
                                            <Zoom in={this.state.showAdditionalInsurancesFields} style={{transitionDelay: this.state.showAdditionalInsurancesFields ? '500ms' : '0ms'}}>
                                                <Grid item xs>
                                                    <TextField
                                                        style={{width: 225}}
                                                        label="MEMBER ID # (Required)"
                                                        variant="outlined"
                                                        value={this.state.cardHolderId2}
                                                        onChange={this.handleCardHolderId2}
                                                    />
                                                </Grid>
                                            </Zoom>

                                            <Zoom in={this.state.showAdditionalInsurancesFields} style={{transitionDelay: this.state.showAdditionalInsurancesFields ? '500ms' : '0ms'}}>
                                                <Grid item xs>
                                                    <TextField
                                                        style={{width: 225}}
                                                        label="RXBIN # (Required)"
                                                        variant="outlined"
                                                        value={this.state.binNumber2}
                                                        onChange={this.handleBinNumber2}
                                                    />
                                                </Grid>
                                            </Zoom>

                                            <Zoom in={this.state.showAdditionalInsurancesFields} style={{transitionDelay: this.state.showAdditionalInsurancesFields ? '500ms' : '0ms'}}>
                                                <Grid item xs>
                                                    <TextField
                                                        style={{width: 225}}
                                                        label="RX GROUP # (Optional)"
                                                        variant="outlined"
                                                        value={this.state.groupNumber2}
                                                        onChange={this.handleGroupNumber2}
                                                    />
                                                </Grid>
                                            </Zoom>

                                            <Zoom in={this.state.showAdditionalInsurancesFields} style={{transitionDelay: this.state.showAdditionalInsurancesFields ? '500ms' : '0ms'}}>
                                                <Grid item xs>
                                                    <TextField
                                                        style={{width: 225}}
                                                        label="RXPCN # (Optional)"
                                                        variant="outlined"
                                                        value={this.state.pcn2}
                                                        onChange={this.handlePcn2}
                                                    />
                                                </Grid>
                                            </Zoom>

                                            <Zoom in={this.state.showAdditionalInsurancesFields} style={{transitionDelay: this.state.showAdditionalInsurancesFields ? '500ms' : '0ms'}}>
                                                <Grid item xs>
                                                    <FormControl component="fieldset">
                                                        <FormGroup style={{width: 225}}>
                                                            <FormControlLabel
                                                                control={<Checkbox checked={this.state.setInsuranceAsPrimary2}/>}
                                                                label="Set Insurance As Primary"
                                                                onChange={this.handleSetInsuranceAsPrimary2}
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Zoom>

                                            <FormControlLabel control={<Switch checked={this.state.showAdditionalInsurancesFields2}
                                                                               onChange={this.handleShowAdditionalInsurancesFields2}/>}
                                                label="Add more insurance"/>

                                            {this.state.showAdditionalInsurancesFields2 && <Grid
                                                container
                                                direction="column"
                                                justify="center"
                                                alignItems="center"
                                                spacing={3}
                                            >
                                                <Zoom in={this.state.showAdditionalInsurancesFields2} style={{transitionDelay: this.state.showAdditionalInsurancesFields2 ? '500ms' : '0ms'}}>
                                                    <Grid item xs>
                                                        <TextField
                                                            style={{width: 225}}
                                                            label="MEMBER ID # (Required)"
                                                            variant="outlined"
                                                            value={this.state.cardHolderId3}
                                                            onChange={this.handleCardHolderId3}
                                                        />
                                                    </Grid>
                                                </Zoom>

                                                <Zoom in={this.state.showAdditionalInsurancesFields2} style={{transitionDelay: this.state.showAdditionalInsurancesFields2 ? '500ms' : '0ms'}}>
                                                    <Grid item xs>
                                                        <TextField
                                                            style={{width: 225}}
                                                            label="RXBIN # (Required)"
                                                            variant="outlined"
                                                            value={this.state.binNumber3}
                                                            onChange={this.handleBinNumber3}
                                                        />
                                                    </Grid>
                                                </Zoom>

                                                <Zoom in={this.state.showAdditionalInsurancesFields2} style={{transitionDelay: this.state.showAdditionalInsurancesFields2 ? '500ms' : '0ms'}}>
                                                    <Grid item xs>
                                                        <TextField
                                                            style={{width: 225}}
                                                            label="RX GROUP # (Optional)"
                                                            variant="outlined"
                                                            value={this.state.groupNumber3}
                                                            onChange={this.handleGroupNumber3}
                                                        />
                                                    </Grid>
                                                </Zoom>

                                                <Zoom in={this.state.showAdditionalInsurancesFields2} style={{transitionDelay: this.state.showAdditionalInsurancesFields2 ? '500ms' : '0ms'}}>
                                                    <Grid item xs>
                                                        <TextField
                                                            style={{width: 225}}
                                                            label="RXPCN # (Optional)"
                                                            variant="outlined"
                                                            value={this.state.pcn3}
                                                            onChange={this.handlePcn3}
                                                        />
                                                    </Grid>
                                                </Zoom>

                                                <Zoom in={this.state.showAdditionalInsurancesFields2} style={{transitionDelay: this.state.showAdditionalInsurancesFields2 ? '500ms' : '0ms'}}>
                                                    <Grid item xs>
                                                        <FormControl component="fieldset">
                                                            <FormGroup style={{width: 225}}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={this.state.setInsuranceAsPrimary3}/>}
                                                                    label="Set Insurance As Primary"
                                                                    onChange={this.handleSetInsuranceAsPrimary3}
                                                                />
                                                            </FormGroup>
                                                        </FormControl>
                                                    </Grid>
                                                </Zoom>
                                            </Grid>}
                                        </Grid>}

                                        <Grid item xs/>
                                    </Grid>}

                                    <FormControlLabel value="Continue Without Insurance" control={
                                        <Radio/>
                                    } label="Continue Without Insurance"/>
                                </RadioGroup>
                            </FormControl>
                        </Grid>}

                        {!showLoadingSpinner &&
                            <MedicationSelection medications={this.props.medications}
                                                 defaultMedication={this.state.defaultMedication}
                                                 medicationList={this.state.medicationList}
                                                 showFakeOutOption={this.state.showFakeOutOption}
                                                 handleMedicationOrVitaminName={this.handleMedicationOrVitaminName.bind(this)}
                                                 addMedication={this.addMedication.bind(this)}
                                                 removeMedication={this.removeMedication.bind(this)} />}

                        {!this.props.forAddPrescription && <Grid item xs>
                            <FormControl>
                                <InputLabel id="allergies-mutiple-chip-label">Common Allergies</InputLabel>
                                <Select
                                    style={{width: 225}}
                                    labelId="allergies-mutiple-chip-label"
                                    id="allergies-mutiple-chip"
                                    multiple
                                    value={this.state.commonAllergies}
                                    onChange={this.handleCommonAllergies}
                                    input={<Input id="select-multiple-chip"/>}
                                    renderValue={(selected) => (
                                        <div>
                                            {(selected as string[]).map((key) => (
                                                // @ts-ignore
                                                <Chip style={{display: 'flex', flexWrap: 'wrap'}} key={COMMON_ALLERGIES.find(i => i.id === key).name} label={COMMON_ALLERGIES.find(i => i.id === key).name}/>
                                            ))}
                                        </div>
                                    )}

                                >

                                    {COMMON_ALLERGIES.map((allergy) => (
                                        <MenuItem key={allergy.name} value={allergy.id}>
                                            {allergy.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>}

                        {this.props.gender === 'Female' &&
                            <Grid item xs>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Pregnant or Nursing</FormLabel>
                                    <RadioGroup aria-label="pregnantOrNursing" name="pregnantOrNursing"
                                                value={this.state.pregnantOrNursing}
                                                onChange={this.handlePregnantOrNursing}
                                                style={{width: 225}}>
                                        <FormControlLabel value="Yes" control={
                                            <Radio/>
                                        } label="Yes"/>
                                        <FormControlLabel value="No" control={
                                            <Radio/>
                                        } label="No"/>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        }

                        {!this.props.forAddPrescription && <Grid item xs>
                            <FormControl>
                                <InputLabel id="health-conditions-mutiple-chip-label">Common Health
                                    Conditions</InputLabel>
                                <Select
                                    style={{width: 225}}
                                    labelId="health-conditions-mutiple-chip-label"
                                    id="health-conditions-mutiple-chip"
                                    multiple
                                    value={this.state.commonHealthConditions}
                                    onChange={this.handleCommonHealthConditions}
                                    input={<Input id="select-multiple-chip"/>}
                                    renderValue={(selected) => (
                                        <div>
                                            {(selected as string[]).map((key) => (
                                                // @ts-ignore
                                                <Chip style={{display: 'flex', flexWrap: 'wrap'}} key={COMMON_HEALTH_CONDITIONS.find(i => i.id === key).name} label={COMMON_HEALTH_CONDITIONS.find(i => i.id === key).name}/>
                                            ))}
                                        </div>
                                    )}
                                >

                                    {COMMON_HEALTH_CONDITIONS.map((healthCondition) => (
                                        <MenuItem key={healthCondition.name} value={healthCondition.id}>
                                            {healthCondition.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>}

                        {!this.props.forAddPrescription && <Grid item xs>
                            <FormControl component="fieldset">
                                <FormGroup style={{width: 225}}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={this.state.staleHealthProfile}/>
                                        }
                                        label="Stale Health Profile"
                                        onChange={this.handleStaleHealthProfile}
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>}

                        {this.props.forCheckout &&
                            <CheckoutFieldsSection medicationList={this.state.medicationList}
                                                   showFakeOutOption={this.state.showFakeOutOption}
                                                   prescriber={this.state.spi}
                                                   ref={(ref) => this.checkoutFieldsSection = ref}/>
                        }

                        {this.props.forOrder &&
                            <CheckoutFieldsSection medicationList={this.state.medicationList}
                                                   showFakeOutOption={false}
                                                   prescriber={this.state.spi}
                                                   showOrderSection={true}
                                                   handleSetAddInsurancePlan = {this.handleSetAddInsurancePlan.bind(this)}
                                                   ref={(ref) => this.checkoutFieldsSection = ref}/>
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    public handleShowAdditionalInsurancesFields(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({showAdditionalInsurancesFields: !this.state.showAdditionalInsurancesFields})
        this.setState({showAdditionalInsurancesFields2: false})
        if (!this.state.showAdditionalInsurancesFields) {
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setMultiInsuranceOrder()
            }
            this.enterDefaultSecondInsuranceInfo()
        } else {
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setSingleInsuranceOrder()
            }
            this.cleanSecondInsuranceInfo()
            this.cleanThirdInsuranceInfo()
        }
    }

    public handleShowAdditionalInsurancesFields2(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({showAdditionalInsurancesFields2: !this.state.showAdditionalInsurancesFields2})
        if (!this.state.showAdditionalInsurancesFields2) {
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setMultiInsuranceOrder()
            }
        } else {
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setSingleInsuranceOrder()
            }
            this.cleanThirdInsuranceInfo()
        }
    }

    public handleInsurancePlan(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({insurancePlan: event.target.value})
        this.setState({showAdditionalInsurancesFields: false})
        this.setState({showAdditionalInsurancesFields2: false})

        if (event.target.value === "Add Insurance Plan") {
            this.setState({addInsurancePlan: true});
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setSingleInsuranceOrder();
            }
        } else {
            this.setState({addInsurancePlan: false});
            if (this.props.forOrder) {
                this.checkoutFieldsSection.getOrderFieldsSection().setCashOrder();
            }
        }
    }

    public handleSetInsuranceAsPrimary(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.checked) {
            this.setState({setInsuranceAsPrimary: true});
            this.setState({setInsuranceAsPrimary2: false});
            this.setState({setInsuranceAsPrimary3: false});

        } else {
            this.setState({setInsuranceAsPrimary: false});
            this.setState({setInsuranceAsPrimary2: false});
            this.setState({setInsuranceAsPrimary3: false});
        }
    }

    public handleStaleHealthProfile(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({staleHealthProfile: event.target.checked})
    }

    public handleCardHolderId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({cardHolderId: event.target.value})
    }

    public handleBinNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({binNumber: event.target.value})
    }

    public handleGroupNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({groupNumber: event.target.value})
    }

    public handlePcn(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({pcn: event.target.value})
    }

    public handleCardHolderId2(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({cardHolderId2: event.target.value})
    }

    public handleBinNumber2(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({binNumber2: event.target.value})
    }

    public handleGroupNumber2(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({groupNumber2: event.target.value})
    }

    public handlePcn2(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({pcn2: event.target.value})
    }

    public handleSetInsuranceAsPrimary2(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.checked) {
            this.setState({setInsuranceAsPrimary: false});
            this.setState({setInsuranceAsPrimary2: true});
            this.setState({setInsuranceAsPrimary3: false});
        } else {
            this.setState({setInsuranceAsPrimary: false});
            this.setState({setInsuranceAsPrimary2: false});
            this.setState({setInsuranceAsPrimary3: false});
        }
    }

    public handleCardHolderId3(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({cardHolderId3: event.target.value})
    }

    public handleBinNumber3(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({binNumber3: event.target.value})
    }

    public handleGroupNumber3(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({groupNumber3: event.target.value})
    }

    public handlePcn3(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({pcn3: event.target.value})
    }

    public handleSetInsuranceAsPrimary3(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.checked) {
            this.setState({setInsuranceAsPrimary: false});
            this.setState({setInsuranceAsPrimary2: false});
            this.setState({setInsuranceAsPrimary3: true});
        } else {
            this.setState({setInsuranceAsPrimary: false});
            this.setState({setInsuranceAsPrimary2: false});
            this.setState({setInsuranceAsPrimary3: false});
        }
    }

    public handlePrescriber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({spi: event.target.value})

        if (event.target.value === 'None') {
            this.setState({addInsurancePlan: false});
            this.setState({insurancePlan: 'Continue Without Insurance'});
        }
    }

    public handleMedicationOrVitaminName(event: React.ChangeEvent<HTMLTextAreaElement>, index: number) {
        const drugId = event.target.value;

        const tempList = this.state.medicationList
        tempList[index] = drugId

        this.setState({medicationList: tempList})
        this.setShowFakeOut(drugId)

        if (this.state.medicationList.length > 1) {
            this.setState({showFakeOutOption: false})
        }

        console.log(this.state.medicationList)
    }

    public handleCommonAllergies(event: React.ChangeEvent<{ value: unknown }>) {
        const allergies = event.target.value as string[];
        const noneAllergy = "523cbe1aad393f143f002a27";
        if (this.state.commonAllergies.indexOf(noneAllergy) > -1) {
            if (allergies.length > 1) {
                while (this.state.commonAllergies.length > 0) {
                    this.state.commonAllergies.splice(0, this.state.commonAllergies.length);
                }
            }

            if (allergies.length === 0) {
                this.setState({commonAllergies: [noneAllergy]});
            } else if (allergies.indexOf(noneAllergy) > -1) {
                allergies.splice(allergies.indexOf(noneAllergy), 1);
                this.setState({commonAllergies: allergies});
            } else {
                this.setState({commonAllergies: allergies});
            }

        } else if (allergies.indexOf(noneAllergy) > -1) {
            while (this.state.commonAllergies.length > 0) {
                this.state.commonAllergies.splice(0, this.state.commonAllergies.length);
            }
            this.setState({commonAllergies: [noneAllergy]});
        } else if (allergies.length === 0) {
            this.setState({commonAllergies: [noneAllergy]});
        } else {
            this.setState({commonAllergies: allergies});
        }
    }

    public handlePregnantOrNursing(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({pregnantOrNursing: event.target.value})
    }

    public handleCommonHealthConditions(event: React.ChangeEvent<{ value: unknown }>) {
        const healthConditions = event.target.value as string[];
        const noneHealthCondition = "548b2cc269702d1e63320000";
        if (this.state.commonHealthConditions.indexOf(noneHealthCondition) > -1) {
            if (healthConditions.length > 1) {
                while (this.state.commonHealthConditions.length > 0) {
                    this.state.commonHealthConditions.splice(0, this.state.commonHealthConditions.length);
                }
            }

            if (healthConditions.length === 0) {
                this.setState({commonHealthConditions: [noneHealthCondition]});
            } else if (healthConditions.indexOf(noneHealthCondition) > -1) {
                healthConditions.splice(healthConditions.indexOf(noneHealthCondition), 1);
                this.setState({commonHealthConditions: healthConditions});
            } else {
                this.setState({commonHealthConditions: healthConditions});
            }

        } else if (healthConditions.indexOf(noneHealthCondition) > -1) {
            while (this.state.commonHealthConditions.length > 0) {
                this.state.commonHealthConditions.splice(0, this.state.commonHealthConditions.length);
            }
            this.setState({commonHealthConditions: [noneHealthCondition]});
        } else if (healthConditions.length === 0) {
            this.setState({commonHealthConditions: [noneHealthCondition]});
        } else {
            this.setState({commonHealthConditions: healthConditions});
        }
    }

    public handleSetAddInsurancePlan(addFirstInsurance: boolean, addSecondInsurance: boolean) {
        if (addFirstInsurance) {
            this.setState({addInsurancePlan: true});
            this.setState({insurancePlan: "Add Insurance Plan"});
            this.setState({showAdditionalInsurancesFields: true});
        } else {
            this.setState({addInsurancePlan: false});
            this.setState({insurancePlan: "Continue Without Insurance"});
        }

        if (addFirstInsurance && addSecondInsurance) {
            this.setState({showAdditionalInsurancesFields: true});
            this.enterDefaultSecondInsuranceInfo()
        } else {
            this.setState({showAdditionalInsurancesFields: false});
            this.cleanSecondInsuranceInfo()
            this.cleanThirdInsuranceInfo()
        }
    }

    public getCheckoutFieldsSection() {
        return this.checkoutFieldsSection;
    }

    public getState() {
        return this.state;
    }

    public addMedication() {
        this.setState({medicationList: [...this.state.medicationList, this.state.defaultMedication]})
        this.setState({showFakeOutOption: false})
    }

    public removeMedication() {
        if (this.state.medicationList.length <= 1) {
            alert('Cannot remove last medication')
            return
        }

        const tempList: any[] = this.state.medicationList
        tempList.pop()

        if (tempList.length === 1) {
            this.setShowFakeOut(tempList[0])
        }

        this.setState({medicationList: tempList})
    }

    private setShowFakeOut(drugId: string) {
        const selectedMedication = this.props.medications.find((medication) => (medication.drugId === drugId))
        if (selectedMedication !== undefined) {
            this.setState({showFakeOutOption: selectedMedication.allowFakeout});
        }
    }

    private enterDefaultSecondInsuranceInfo() {
        this.setState({cardHolderId2: '123456789'})
        this.setState({binNumber2: '456789'})
        this.setState({groupNumber2: '199'})
        this.setState({pcn2: 'XVRPAY'})
    }

    private cleanSecondInsuranceInfo() {
        this.setState({cardHolderId2: ''})
        this.setState({binNumber2: ''})
        this.setState({groupNumber2: ''})
        this.setState({pcn2: ''})
    }

    private cleanThirdInsuranceInfo() {
        this.setState({cardHolderId3: ''})
        this.setState({binNumber3: ''})
        this.setState({groupNumber3: ''})
        this.setState({pcn3: ''})
    }
}

export default HealthProfileFieldsSection
